<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div v-if="error" class="row">
            <div class="col-12 text-center">
              <h2 class="title text-danger">{{error.status}}</h2>
              <h2 class="title" v-if="error.status === 404">صفحه مورد نظر پیدا نشد</h2>
              <h2 class="title" v-else>{{error.message}}</h2>
            </div>
          </div>

        </div>
      </div>
    </div>
    <footer class="footer-demo">
      <div class="container">
        <nav class="pull-left">
          <ul>
            <li>
              <router-link :to="{path:'/'}">Home</router-link>
            </li>
            <li>
              <router-link :to="{path:'/register'}">Register</router-link>
            </li>
          </ul>
        </nav>

      </div>
    </footer>
  </div>
</template>
<script>
  export default {
    data() {
      const error = this.$route.params.error || {status: 404, message: 'Page Not Found'}

      return {
        error
      }
    },

    mounted() {
      // console.log(error)
    }
  };
</script>
